import { useAdNetworksQuery } from '../../../features/insights/useAdNetworksQuery';
import { translate } from '../../../services/i18n';
import { formatToMonthYear } from '../../../services/timeFormat';
import { SectionHeader } from '../SectionHeader';
import { StyledSectionView } from '../styles';

import { AdNetworksTable } from './AdNetworksTable';

export const AdNetworks = () => {
  const { data } = useAdNetworksQuery();

  return (
    <StyledSectionView data-automation="AdNetworksSection">
      <SectionHeader
        title={translate('company.ad-networks')}
        showWorldwideIcon
        websource="desktop"
        dateInfo={data?.date ? formatToMonthYear(data.date) : ''}
        infoIconTooltip={translate('company.ad-networks.info.tooltip')}
      />
      <AdNetworksTable />
    </StyledSectionView>
  );
};
